import { AspectRatio } from "@pages/videoCreating/videoCreatingSlice";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import report from "@report";

// 图片宽高比 （竖屏 9:16 / 横屏 16:9）
const normalizeAspectRatio = (v?: AspectRatio | string): AspectRatio => {
  if (v === "RATIO_16_9" || v === "16:9") return "RATIO_16_9";
  return "RATIO_9_16";
};

export interface DownloadingItem {
  type: DOWNLOAD_TYPE;
  region: string;
  videoId: string;
  finish: boolean;
}

type DOWNLOAD_TYPE = "video" | "script";

interface InitialState {
  videoDisplay: boolean;
  videoType: VIDEO_TYPE;
  videoURL: string;
  videoId?: string;
  videoSource?: string;
  downloadingItems: DownloadingItem[];
  region?: string;
  videoNotFound?: boolean;
  aspectRatio?: AspectRatio;
  hideDownload?: boolean;
}

const initialState: InitialState = {
  videoDisplay: false,
  videoType: "video_btn",
  videoURL: "",
  videoId: "",
  videoSource: "",
  downloadingItems: [],
  region: undefined,
  videoNotFound: true,
  aspectRatio: "RATIO_9_16",
};

export const globalSlice = createSlice({
  name: "globalVideo",
  initialState,
  reducers: {
    showVideoDisplay: (
      state,
      action: PayloadAction<{
        url?: string;
        type: VIDEO_TYPE;
        region?: string;
        videoId?: string;
        videoURL?: string;
        videoSource?: string;
        kalo_pos?: string;
        aspectRatio?: AspectRatio | string;
        hideDownload?: boolean;
      }>,
    ) => {
      state.videoType = action.payload.type;
      state.region = action.payload.region;
      state.videoId = action.payload.videoId || "";
      state.videoURL = action.payload.videoURL || "";
      state.videoSource = action.payload.videoSource || "";
      state.aspectRatio =
        action.payload.aspectRatio != null ? normalizeAspectRatio(action.payload.aspectRatio) : state.aspectRatio;
      state.hideDownload = action.payload.hideDownload ?? false;
      state.videoDisplay = true;

      report.click({
        kalo_pos: action.payload.kalo_pos || "video",
        kalo_type: "open",
        kalo_value: state.videoId,
      });
    },
    hideVideoDisplay: (state) => {
      state.videoType = "";
      state.videoId = "";
      state.videoSource = "";
      state.aspectRatio = "RATIO_9_16";
      state.hideDownload = false;
      state.videoDisplay = false;
      report.click({ kalo_pos: "video", kalo_type: "close", kalo_value: state.videoId });
    },
    updateDownloadingVideos: (state, action: PayloadAction<{ region: string; videoId: string }>) => {
      if (!state.downloadingItems.find((item) => item.videoId === action.payload.videoId && item.type === "video")) {
        state.downloadingItems = [
          ...state.downloadingItems,
          { region: action.payload.region, videoId: action.payload.videoId, finish: false, type: "video" },
        ];
      }
    },
    updateDownloadingScript: (state, action: PayloadAction<{ region: string; videoId: string }>) => {
      if (!state.downloadingItems.find((item) => item.videoId === action.payload.videoId && item.type === "script")) {
        state.downloadingItems = [
          ...state.downloadingItems,
          { region: action.payload.region, videoId: action.payload.videoId, finish: false, type: "script" },
        ];
      }
    },
    finishDownloadVideo: (state, action: PayloadAction<string>) => {
      const index = state.downloadingItems.findIndex(
        (item) => item.videoId === action.payload && item.type === "video",
      );
      const downloadItems = [...state.downloadingItems];
      downloadItems.splice(index, 1);
      state.downloadingItems = downloadItems;
    },
    finishDownloadScript: (state, action: PayloadAction<string>) => {
      const index = state.downloadingItems.findIndex(
        (item) => item.videoId === action.payload && item.type === "script",
      );
      const downloadItems = [...state.downloadingItems];
      downloadItems.splice(index, 1);
      state.downloadingItems = downloadItems;
    },
    updateVideoUnFound: (state, action: PayloadAction<boolean>) => {
      state.videoNotFound = action.payload;
    },
  },
});

export const {
  showVideoDisplay,
  hideVideoDisplay,
  updateDownloadingVideos,
  updateDownloadingScript,
  finishDownloadVideo,
  finishDownloadScript,
  updateVideoUnFound,
} = globalSlice.actions;

const globalReducer = globalSlice.reducer;
export default globalReducer;
